import { IonContent, IonPage, IonTitle } from '@ionic/react';
import { ReactElement, useRef } from 'react';
import { RouteChildrenProps, useParams } from 'react-router';
import { Machine, useGetMachineQuery } from '../../api/graphql/generated';
import { NestedPageHeader } from '../../components/header/page.header';
import { FileVersion } from '../../components/machine/file-version';
import { MachineProgramStatus } from '../../components/machine/machine-program-status';
import { useBeaconRouter } from '../../route/route.hooks';
import { useQueryParameters } from '../../util/router';

interface RouteParams {
  id: string;
}

interface FileVerionsPageProps extends RouteChildrenProps {
  teamId: string;
}

const FileVerionsPage = (props: FileVerionsPageProps): ReactElement => {
  const { teamId } = props;

  const params = useParams<RouteParams>();
  const { id } = params;

  const { data } = useGetMachineQuery({
    variables: { input: { id, teamId } },
  });
  const queryParams = useQueryParameters();

  const path = queryParams.get('path');
  const filePath = useRef<string | null>(path);

  const machine: Machine | undefined = data?.getMachine;

  const { builder } = useBeaconRouter();

  return (
    <IonPage>
      <NestedPageHeader defaultBackRoute={builder.getMachineRoute(teamId, id)}>
        <IonTitle>
          {machine?.name}
          <div className="subtitle header-program-status">
            <MachineProgramStatus machine={machine} />
          </div>
        </IonTitle>
      </NestedPageHeader>
      <IonContent>
        <FileVersion machine={machine} filePath={filePath.current} />
      </IonContent>
    </IonPage>
  );
};

export { FileVerionsPage };
